import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import uuid from 'node-uuid'
import { selectShouldRenderAds } from 'services/bootup/selectors'
import { selectAdUnitPath } from 'services/ads/selectors'
import { selectShouldSeeAds } from 'services/premium/selectors'
import { selectPathname } from 'services/routing/selectors'
import { targetWithCriteo } from './utils'

function mapStateToProps (state) {
  return {
    adUnitPath: selectAdUnitPath(state),
    shouldSeeAds: selectShouldSeeAds(state),
    pathname: selectPathname(state),
    shouldRenderAds: selectShouldRenderAds(state),
  }
}

class Interstitial extends Component {

  static propTypes = {
    adUnitPath: PropTypes.string.isRequired,
    shouldSeeAds: PropTypes.bool.isRequired,
    pathname: PropTypes.string.isRequired,
    shouldRenderAds: PropTypes.bool.isRequired,
  }

  shouldComponentUpdate (nextProps) {
    const { pathname, adUnitPath, shouldSeeAds } = this.props
    const pathnameChanged = pathname !== nextProps.pathname
    const adUnitPathChanged = adUnitPath !== nextProps.adUnitPath
    return shouldSeeAds && (pathnameChanged || adUnitPathChanged)
  }

  componentWillUpdate () {
    this.id = uuid.v4()
    this.destroySlot()
  }

  componentDidUpdate () {
    this.createSlot()
  }

  componentWillUnmount () {
    this.destroySlot()
  }

  createSlot = () => {
    const { adUnitPath, shouldRenderAds } = this.props
    const { googletag } = window
    const { id } = this
    if (adUnitPath === '' || !shouldRenderAds) { return }
    googletag.cmd.push(() => {
      targetWithCriteo()
      this.slot = googletag.defineOutOfPageSlot(adUnitPath, id)
      this.slot.addService(googletag.pubads())
      googletag.enableServices()
      googletag.display(id)
    })
  }

  destroySlot = () => {
    if (this.slot) { window.googletag.destroySlots([this.slot]) }
  }

  render () {
    const { shouldSeeAds } = this.props
    const { id } = this
    const style = { position: 'absolute', bottom: 0, left: 0 }
    return shouldSeeAds ? <div id={id} style={style} /> : null
  }

}

export default connect(mapStateToProps)(Interstitial)



// WEBPACK FOOTER //
// ./src/components/util/ads/Interstitial.jsx